import { backgroundColor } from './backgroundColor.js';
import { borders } from './border.js';
import { flexes } from './flex.js';
import { positions, display, cursor } from './layout.js';
import { opacity } from './opacity.js';
import { overflows } from './overflow.js';
import { shadow } from './shadow.js';
import { spacings } from './spacing.js';
import { compose } from './theme.js';
import { typography } from './typography.js';

const system = compose(borders, backgroundColor, cursor, shadow, spacings, typography, display, positions, flexes, overflows, opacity);

export { system };
